import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { Grid } from './QuoteListProducts.styles'

const QuoteListProducts = props => {
  const { code, description, name, quantity, unitMeasure } = props

  const {
    size: { isDownToTiny }
  } = useViewport()

  return (
    <Card enableBorder color="blank" margin="4px 0 0">
      <Grid container spacing={2}>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
            {name}
          </Typography>
          <Typography color="black3" fontSize="13px" fontWeight="bold" lineHeight="18px" variant="body2">
            {`ID: ${code}`}
          </Typography>
        </Grid>
        <Grid item sm={7} xs={12}>
          <Typography color="black1" fontSize="14px" lineHeight="18px" variant="body2">
            {description}
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          <Grid container justifyContent={!isDownToTiny && 'flex-end'}>
            <Typography color="black3" fontSize="14px" lineHeight="18px" variant="body2">
              Cantidad
            </Typography>
          </Grid>
          <Grid container justifyContent={!isDownToTiny && 'flex-end'}>
            <Typography color="black1" fontSize="16px" fontWeight="bold" lineHeight="26px" variant="h3">
              {quantity} {unitMeasure}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  )
}

QuoteListProducts.propTypes = {
  code: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  unitMeasure: PropTypes.string.isRequired
}

export default QuoteListProducts
